import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SelectField from "../../../common/SelectField";

import { FormControl } from "@mui/material";
import { useFormik, yupToFormErrors } from "formik";
import * as Yup from "yup";

import InputField from "../../../common/CustomInputField";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  minWidth: "350px !important",

  background: "color.white",
  boxShadow:
    "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  padding: "0px 0 10px 0",
  display: "flex",
  flexDirection: "column",
};

export default function BasicModal(props) {
  const {
    open,
    handleClose,
    addRow,
    relationships,
    selectedRow = {},
    selectedSubOwnerIndex,
  } = props;
  const { t } = useTranslation();
  const { id: rowId } = selectedRow;

  const initialValues =
    Object.keys(selectedRow).length > 0
      ? { ...selectedRow, dateOfBirth: selectedRow.dateOfBirth.slice(0, 10) }
      : {
          relationship: "",
          name: "",
          dateOfBirth: "",
          shares: "",
          value: "",
        };
  const validate = Yup.object({
    relationship: Yup.string(t("valid-character"))
      .required(t("required"))
      .max(50, t("max-50-characters")),
    name: Yup.string(t("valid-character"))
      .required(t("required"))
      .max(50, t("max-50-characters")),
    shares: Yup.number("Must be a valid Number")
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100"))
      .required(t("required")),
    value: Yup.number("Must be a valid Number")
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits"))
      .required(t("required")),
    dateOfBirth: Yup.string()
      .required(t("required"))
      .test("DATE", t("between-1950-2050"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          return 1950 <= yyyy && yyyy <= 2050;
        }
      }),
  });
  const onSubmit = async (values, onSubmitProps) => {
    addRow(values);
    onSubmitProps.resetForm();
    handleClose();
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validate,
    enableReinitialze: true,
  });
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <Box sx={style}>
            <Box
              lg={12}
              sx={{
                backgroundColor: "color.magentaLight2",
                padding: "10px",
                color: "color.brown",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography id="modal-modal-title" pl={3} component="p">
                {t("SharesOfInheritance")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  onClick={() => handleClose()}
                  sx={{
                    cursor: "pointer",
                  }}
                  pr={1}
                  variant="h6"
                  component="h2"
                >
                  X
                </Typography>
              </Box>
            </Box>

            <FormControl sx={{ width: "100%", padding: "20px " }}>
              {/* <InputField
                label="RelationShip"
                name="relationship"
                placeholder="Relationship"
                value={formik.values.relationship}
                onChange={formik.handleChange}
                error={
                  Boolean(
                    formik?.errors?.relationship &&
                      formik?.touched?.relationship
                  )
                    ? formik.errors
                    : null
                }
              /> */}
              <SelectField
                label={t("input-15")}
                value={formik.values?.relationship}
                onChange={(item) => {
                  formik.setFieldValue("relationship", item.name);
                }}
                menuList={relationships}
                error={formik.errors}
              />

              <InputField
                label={t("soi-heading-2")}
                name="name"
                placeholder="Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={
                  Boolean(formik?.errors?.name && formik?.touched?.name)
                    ? formik.errors
                    : null
                }
              />
              <InputField
                type="date"
                label={t("input-2")}
                value={formik.values.dateOfBirth}
                onChange={formik.handleChange}
                name="dateOfBirth"
                placeholder="Date"
                error={
                  Boolean(
                    formik?.errors?.dateOfBirth && formik?.touched?.dateOfBirth
                  )
                    ? formik.errors
                    : null
                }
              />
              <InputField
                type="number"
                label={t("soi-heading-3")}
                name="shares"
                placeholder="Shares"
                value={formik.values.shares}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("shares", value);
                  formik.setFieldValue(
                    "value",
                    Math.ceil(Number(props.totalAmount) * (value / 100))
                  );
                }}
                error={
                  Boolean(formik?.errors?.shares && formik?.touched?.shares)
                    ? formik.errors
                    : null
                }
              />
              <InputField
                type="number"
                label={t("soi-heading-4")}
                name="value"
                placeholder="Value"
                value={formik.values.value}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("value", value);
                  formik.setFieldValue(
                    "shares",
                    Math.ceil(
                      (Number(value || 0) / Number(props.totalAmount)) * 100
                    )
                  );
                }}
                error={
                  Boolean(formik?.errors?.value && formik?.touched?.value)
                    ? formik.errors
                    : null
                }
              />
            </FormControl>

            <Button
              sx={{
                color: "color.brown",
                padding: "8px 50px",
                backgroundColor: "color.magentaLight2",
                margin: "4rem auto 1rem auto",
                fontWeight: "bold",
                borderRadius: "15px",
                textTransform: "initial",
                "&:hover": {
                  backgroundColor: "color.magentaLight1",
                  boxShadow: "none",
                },
              }}
              onClick={() => formik.handleSubmit()}
            >
              {t("save")}
            </Button>
          </Box>
        </div>
      </Modal>
    </div>
  );
}
